require('./backupsWidget.style.scss');

const DAY = 1000 * 60 * 60 * 24 + 100;

class BackupsWidgetController {
    constructor($scope, $filter, $rootScope, styleService, dashboardService, sharedPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.dateFilter = $filter('localizeDate');
        this._dashboardService = dashboardService;
        this.ENDPOINT = sharedPersistenceService.getRestEndpoints().BACKUPS_WIDGET_REST;
        this.graphColors = styleService.getGraphColors('backups');
        this.period = DAY * 6;
        this.data = {
            graph1: []
        };
        this.details = '0%';
        this.percentageBar = _.fill(Array(20), 'percentage-empty');
    }

    $onInit() {
        this.updateData();

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        let bkpCtrlTime = this.widgetData.backupControllerTime,
            startBctrlTime = moment().startOf('day').toDate().getTime();
        if (bkpCtrlTime) {
            let d = new Date(bkpCtrlTime);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            d.setMilliseconds(0);
            startBctrlTime = d.getTime();
        }
        this.start = startBctrlTime;
        let graph = [];
        for (let i = 0; i < 7; i++) {
            graph[i] = {};
            if (this.widgetData.successCount[i] + this.widgetData.failedCount[i] === 0) {
                graph[i].y = 100;
            } else {
                graph[i].y = Math.round(100 * this.widgetData.successCount[i] / (this.widgetData.successCount[i] + this.widgetData.failedCount[i]));
            }
            graph[i].x = startBctrlTime - DAY * i;
            graph[i].count = 'Total Count: ' + (this.widgetData.successCount[i] + this.widgetData.failedCount[i]);
        }
        this.data = { graph1: graph };
        let average = Math.round((this.widgetData.backupSuccessRate * 100) * 100) / 100;
        this.details = average + '%';
        if (average < 5 && average > 0) average = 5;
        if (average < 100 && average > 95) average = 95;
        this.percentageBar.forEach((elem, i) => {
            if (average > (i + 1) * 5 - 2.5) {
                this.percentageBar[i] = 'percentage-green';
            }
            else {
                this.percentageBar[i] = 'percentage-red';
            }
        });
        this.successCount = this.widgetData.successCount;
        this.failedCount = this.widgetData.failedCount;
        this.progressAverage = Math.round(average);
    }
}

BackupsWidgetController.$inject = ['$scope', '$filter', '$rootScope', 'styleService', 'dashboardService', 'sharedPersistenceService'];

const backupsWidgetController = {
    controller: BackupsWidgetController,
    template: require('./backupsWidget.template.html'),
    bindings: { widgetData: '<' },
};

module.exports = backupsWidgetController;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/backupsWidget/backupsWidget.component.js